import type { WorkOrderBatchActionResponse } from "../../../../../../../../../../../api/kehrblatt/work-orders"
import { buildCompleteWorkOrderApprovalDescription } from "../../../../../../../../../_shared/_logic/components-work-orders-action-tooltips"
import type { WorkOrderRow } from "../../../../../../../_shared/_logic/work-order-table-model"

export type BatchActionNotificationLabels = {
  singular: string
  plural: string
  actionText: string
  failureText: string
}

export type BatchActionNotification = {
  class: "success" | "warning" | "error"
  html: string
}

export const selectedWorkOrderRows = (rows: unknown[]): WorkOrderRow[] =>
  rows.filter((row): row is WorkOrderRow =>
    Boolean((row as WorkOrderRow)?.id && (row as WorkOrderRow)?.workOrder),
  )

export const buildCompleteBatchDescription = (count: number) => {
  return buildCompleteWorkOrderApprovalDescription(count)
}

export const buildBatchActionNotification = (
  result: WorkOrderBatchActionResponse,
  labels: BatchActionNotificationLabels,
): BatchActionNotification => {
  const processed = result.processed_count ?? 0
  const skipped = result.skipped_count ?? 0
  const failed = result.failed_count ?? 0

  if (processed > 0) {
    const noun = processed === 1 ? labels.singular : labels.plural
    const suffix = [
      skipped ? `${skipped} übersprungen` : null,
      failed ? `${failed} fehlgeschlagen` : null,
    ]
      .filter(Boolean)
      .join(", ")

    return {
      class: skipped || failed ? "warning" : "success",
      html: `${processed} ${noun} ${labels.actionText}.${suffix ? ` ${suffix}.` : ""}`,
    }
  }

  if (skipped || failed) {
    const firstIssue = result.failed?.[0] ?? result.skipped?.[0]

    return {
      class: "warning",
      html: firstIssue?.message ?? labels.failureText,
    }
  }

  return {
    class: "error",
    html: labels.failureText,
  }
}
